import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import Datetime from 'react-datetime';
import moment from 'moment';
import { OverlayTrigger, Popover } from 'react-bootstrap';
import Select from 'react-select-plus';
import gql from 'graphql-tag';
import { withApollo } from 'react-apollo';
import { Icon, Button } from 'modules/common/components';
import { router } from 'modules/common/utils';
import { dimensions, colors, typography } from '../styles';
import { searchCompany } from 'modules/common/utils';
import {
  FormControl,
  FormGroup,
  ControlLabel
} from 'modules/common/components';

const PopoverButton = styled.div`
  display: inline-block;
  position: relative;

  > * {
    display: inline-block;
  }

  button {
    padding: 0;
  }

  i {
    margin-left: 5px;
    margin-right: 0;
    font-size: 10px;
    transition: all ease 0.3s;
    color: ${colors.colorCoreGray};
  }

  &[aria-describedby] {
    color: ${colors.colorSecondary};

    i {
      transform: rotate(180deg);
    }
  }

  &:hover {
    cursor: pointer;
  }
`;

const FlexRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 5px ${dimensions.unitSpacing}px;

  .form-control {
    box-shadow: none;
    border-radius: 4px;
    border: 1px solid ${colors.themeBlue};
    background: none;
    /* border-bottom: 1px solid ${colors.colorShadowGray}; */
    padding: 7px 14px;
    font-size: 13px;
    height:50px;
    /* box-shadow: none;
    border-radius: 0;
    border: none;
    background: none;
    border-bottom: 1px solid ${colors.colorShadowGray};
    padding: 17px 14px;
    font-size: ${typography.fontSizeBody}px; */

    &:focus {
      box-shadow: none;
      border-color: ${colors.colorPrimary};
    }
  }
`;

const FlexItem = styled.div`
  flex: 1;
  margin-left: 5px;
`;

const DateFilters = styled.div`
  width: 305px;

  button {
    padding: 5px 20px;
  }
`;

const propTypes = {
  queryParams: PropTypes.object,
  history: PropTypes.object,
  client: PropTypes.object,
  countQuery: PropTypes.string,
  countQueryParam: PropTypes.string
};

const format = 'YYYY-MM-DD HH:mm';

class ProjectFilter extends React.Component {
  constructor(props) {
    super(props);
    const { project } = props.queryParams;
    this.state = {
      projects: null,
      projectId: '',
      projectName: ''
    };
    this.renderPopover = this.renderPopover.bind(this);
    this.handleProjectSearch = this.handleProjectSearch.bind(this);
    //this.refetchCountQuery = this.refetchCountQuery.bind(this);
    //this.renderCount = this.renderCount.bind(this);
    //this.onDateChange = this.onDateChange.bind(this);
    this.filterByPhone = this.filterByPhone.bind(this);
  }

  handleProjectSearch(value) {
    searchCompany(value, projects => this.setState({ projects }));
  }

  filterByPhone() {
    const { projectId, projectName } = this.state;
    router.setParams(this.props.history, {
      projects: projectId,
      projectName: projectName
    });
  }

  renderFormGroup(label, props) {
    return (
      <FormGroup>
        <ControlLabel>{label}</ControlLabel>
        <FormControl {...props} />
      </FormGroup>
    );
  }

  generateProjectParams(projects) {
    if (projects) {
      return projects.map(project => ({
        value: project._id,
        label: project.name || ''
      }));
    }
  }

  renderPopover() {
    const { __ } = this.context;
    const { projects } = this.state;
    var _this = this;
    return (
      <Popover id="filter-popover" title={__('Filter by Project')}>
        <DateFilters>
          <FlexRow>
            <FlexItem>
              <Select
                placeholder={__('Search')}
                onFocus={() =>
                  this.state.projects &&
                  projects.length < 1 &&
                  this.handleProjectSearch('')
                }
                onInputChange={this.handleProjectSearch}
                onChange={selectedOption => {
                  _this.setState({
                    projectId: selectedOption ? selectedOption.value : null,
                    projectName: selectedOption ? selectedOption.label : null
                  });
                }}
                value={this.state.projectId}
                options={this.generateProjectParams(projects)}
              />
            </FlexItem>
          </FlexRow>

          <FlexRow>
            <Button btnStyle="simple" onClick={() => this.filterByPhone()}>
              Filter
            </Button>
          </FlexRow>
        </DateFilters>
      </Popover>
    );
  }

  render() {
    const { __ } = this.context;

    return (
      <OverlayTrigger
        ref={overlayTrigger => {
          this.overlayTrigger = overlayTrigger;
        }}
        trigger="click"
        placement="bottom"
        overlay={this.renderPopover()}
        container={this}
        shouldUpdatePosition
        rootClose
      >
        <PopoverButton>
          {__('Project')} <Icon icon="downarrow" />
        </PopoverButton>
      </OverlayTrigger>
    );
  }
}

ProjectFilter.propTypes = propTypes;
ProjectFilter.contextTypes = {
  __: PropTypes.func
};

export default withApollo(ProjectFilter);



// WEBPACK FOOTER //
// ./src/modules/theme/theme1/common/components/ProjectFilter.js